'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';

/**
 * Upload with progress value
 * Only in XMLHttpRequest allow for addEventListener
 */
var uploadFile = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var file, apiUpload, onProgress, onLoad_1, onError_1, data, request_1;
    return __generator(this, function (_a) {
        try {
            file = params.file, apiUpload = params.apiUpload, onProgress = params.onProgress, onLoad_1 = params.onLoad, onError_1 = params.onError;
            data = new FormData();
            data.append('file', file);
            data.append('jobId', '0');
            data.append('jobseekerId', '0');
            request_1 = new XMLHttpRequest();
            request_1.open('POST', apiUpload);
            // upload progress event
            onProgress && request_1.upload.addEventListener('progress', onProgress);
            // Error progress event
            onError_1 &&
                request_1.addEventListener('error', function (e) {
                    onError_1(e.type);
                });
            // request finished event
            onLoad_1 &&
                request_1.addEventListener('load', function () {
                    onLoad_1(request_1);
                });
            // send POST request to server
            request_1.send(data);
        }
        catch (ex) {
            console.error('upload error', ex);
        }
        return [2 /*return*/];
    });
}); };

export { uploadFile };
//# sourceMappingURL=services.js.map
